if ($.fn.select2) {
    $.fn.select2.defaults.set("language", "pt-BR");
}